import React, { useEffect, useState } from "react";
import StyledTable from "../../Reusablecomponents/UITable/UITable";
import { SearchOutlined } from "@ant-design/icons";
import styled from "styled-components";
import filtericon from "../../assets/images/filter-svgrepo-com (1).svg";
import dayjs from "dayjs";
import { useMemo } from "react";
import { WrapperBox } from "../Operations/Fuelentry/Consignment Operation/Consignment1";
import {
  Button,
  Input,
  Avatar,
  Badge,
  Select,
  Checkbox,
  Switch,
  Row,
  Col,
  Form,
  message,
  Spin,
} from "antd";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../Reusablecomponents/UIButtons"; // Custom Button component
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../Reusablecomponents/ReusableDrawer";
import UIModal from "../../Reusablecomponents/UIModal/index";
import { CALL_API } from "../../Common/api";
import ReusablePagination from "../../Reusablecomponents/ReusablePagination";
import { DatePicker } from "antd";
import moment from "moment";
import { useSelector } from "react-redux";
import { render } from "@testing-library/react";
import { uniqBy } from "lodash";
const { Option } = Select;



const StyledInput = styled(Input)`
  width: 312px !important; // Set the desired width
  height: 39px;
  border-radius: 24px;
`;
const Customstyle = styled.div`
  background-color: white;

  .topstyle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    backgroundcolor: white;
  }
  .total {
    color: #5f6d8c;
    font-size: 16px;
    font-weight: 400;
    margin-left: 15px;
  }
  .searchstyle {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .filterstyle {
    height: 25px;
    width: 25px;
    backgroundcolor: #ebf7ed;
  }
  .badge {
    padding: 6px;
    cursor: pointer;
  }
  .custom-row-height {
    height: 88px !important; /* Set desired row height */
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .ant-checkbox-inner {
    width: 24px !important;
    height: 24px !important;
    border-radius: 6px !important;
    border: 1.5 px #d0d5dd !important; /* Unchecked border color */
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #2c963d !important;
    border-color: #2c963d !important;
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner {
    border-color: #d0d5dd !important;
  }

  .modal-container {
  }

  .form-row {
    display: flex;
    gap: 16px;
  }

  .form-field {
    flex: 1;
  }

  .form-label {
    width: 57px;
    height: 17px;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    text-align: left;
    color: #5f6d8c;
    margin-bottom: 8px;
  }

  .form-select,
  .form-input {
    width: 251px;
    height: 36px;
    padding: 8px;
    border-radius: 20px;
    border: 1px solid #e7e7ed;
    background-color: #ffffff;
    color: #363636;
  }

  .message-type-label {
    margin-right: 16px;
  }

  .message-type-checkbox {
    margin-right: 4px;
  }

  .clear-all-button {
    text-align: right;
    margin-top: 16px;
  }

  .clear-all-btn {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    background-color: #ccc;
    cursor: pointer;
  }
`;

function Notification() {
  const [form] = Form.useForm();
  const [showModal, SetshowModal] = useState(false);
  const [filterform] = Form.useForm();
   const values = filterform.getFieldsValue("consignee");
console.log(values, "values111--->");

  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const consigneeLists = useSelector(
    (state) => state?.authTracking?.consigneeList
  );
  console.log(consigneeLists, "consigneeLists--->");
  const driverWithVehicles = useSelector(
    (state) => state?.authTracking?.driverWithVehicle
  );
    const  consignerList  = useSelector((state) => state?.authTracking?.consignerList
);
console.log(consignerList
   , "consignerList")

  const vehicleLists = useSelector((state) => state?.authTracking?.vehicleList);
  console.log(driverWithVehicles, "driverWithVehicles");
  console.log(vehicleLists, "vehicleLists--->");
     const transporterList
     = useSelector((state) => state?.authTracking?.transporterList)
     console.log(transporterList , "transporterList")
  const uniqueVehicleLists = useMemo(() => {
    const seen = new Set();
    return vehicleLists?.filter((vehicle) => {
      if (seen.has(vehicle.REGNO)) return false;
      seen.add(vehicle.REGNO);
      return true;
    });
  }, [vehicleLists]);

  const [isConformationModal, setIsConformationModal] = useState(false);
  const [newLoading, setNewLoading] = useState(false);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [selectedKeys, setSelectedKeys] = useState([]);
  console.log(selectedKeys , "selectedKeysselectedKeys")
  const [loading, setLoading] = useState(false);
  const [notificationList, setNotificationList] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [filterData, setFilterData] = useState({
    duration: "current_month",
    daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
  });
    console.log(filterData , "filterData--->");


  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  // const fetchNotificationLog = async (values) => {
  //   console.log("values-->", values);
  //   setLoading(true);
  //   const { data } = await CALL_API("POST", `notifications/pagination`, {
  //     page: 1,
  //     pageSize: 10,
  //     whereClauses: {
  //       MCID: 24,
  //       MSGTYPE:'',
  //       READON: "2022-01-21 05:27:20.577",
  //       DATEFROM: "",
  //       DATETO: "",
  //     },
  //   });
  //   setNotificationList(data?.notifications[0] || []);
  //   setTotal(data?.totalRecords || 0);
  //   setLoading(false);
  //   console.log("data--->", data);
  // };

  //http://127.0.0.1:3000/notif/getNotificationList


  console.log("values--->", values);  
  const fetchNotificationLog = async (values) => {
    console.log("userInfo--->", userInfo);
    console.log("values1231-->", values);
    setLoading(true);
    const { data } = await CALL_API("POST", `notif/getNotificationList`, {
     


CUSTNAME: "" ,
DATEFROM: filterData?.daterange?.[0] ? filterData.daterange[0].format("YYYY-MM-DD") : "",
DATETO: filterData?.daterange?.[1] ? filterData.daterange[1].format("YYYY-MM-DD") : "",
DRIVERNAME:filterData?.driver ,
MCID:userInfo?.MCID,
MSGTYPE: filterData?.messagetype,
READON: filterData?.status,
RECNAME: filterData?.consignee , 
REGNO : filterData?.vehicle ,
skip :(currentPage - 1) * pageSize,
SUPNAME:"",
take:pageSize,


      
    });
    setNotificationList(data?.data?.recordsets[0] || []);
    setTotal(data?.total || 0);
    setLoading(false);
    console.log("data--->", data?.data?.recordsets[0]);
  };

  console.log("notificationList--->", notificationList);
  console.log("total--->", total);

  console.log("formgetfieldvalue--->", form.getFieldValue("duration"));

  useEffect(() => {
    fetchNotificationLog();
  }, [currentPage, pageSize, 
    filterData
  ]);

  const duration = Form.useWatch("Duration", form); // Watch 'Duration' field
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList
  );
  const vehicleList = useSelector((state) => state?.authTracking?.vehicleList);
  const driverList = useSelector((state) => state?.authTracking?.driverList);
  const [filterCount, setFilterCount] = useState(0);
console.log(filterCount , "filterCount-->")

  

  // console.log(filterData?.daterange[0], "filterData?.daterange");
  // console.log(filterData?.daterange[1], "filterData?.daterange1");

  const [formData, SetformData] = useState({
    consignee: "",
    driver: "",
    status: "",
    vehicle: "",
    duration: "current_month",
    messagetype: "",
    daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
  });

  console.log("filterform--->", filterform);
  useEffect(() => {
    const duration = filterform.getFieldValue("duration");
    console.log(duration, "duration--->");

    console.log(filterform.getFieldValue("duration"), "duration1--->");

    if (duration === "current_month") {
      const range = [dayjs().startOf("month"), dayjs().endOf("month")];
      form.setFieldValue("daterange", range);
      setFilterData((prev) => ({ ...prev, daterange: range }));
    } else if (duration === "current_year") {
      const range = [dayjs().startOf("year"), dayjs().endOf("year")];
      form.setFieldValue("daterange", range);
      setFilterData((prev) => ({ ...prev, daterange: range }));
    } else if (duration === "last_month") {
      const range = [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ];
      form.setFieldValue("daterange", range);
      setFilterData((prev) => ({ ...prev, daterange: range }));
    } else if (duration === "today") {
      const range = [dayjs(), dayjs()];
      form.setFieldValue("daterange", range);
      setFilterData((prev) => ({ ...prev, daterange: range }));
    } else if (duration === "---") {
      const range = [null, null];
      form.setFieldValue("daterange", range);
      setFilterData((prev) => ({ ...prev, daterange: range }));
    }
  }, [filterData.duration ,formData , duration]);

  // useEffect(() => {
  //     if (form.getFieldValue("duration") === "last_month") {
  //       form.setFieldValue("daterange", [
  //         moment().subtract(1, "months").startOf("month"),
  //         moment().subtract(1, "months").endOf("month"),
  //       ]);
  //     } else if (form.getFieldValue("duration") === "current_month") {
  //       form.setFieldValue("daterange", [
  //         moment().startOf("month"),
  //         moment().endOf("month"),
  //       ]);
  //     } else if (form.getFieldValue("duration") === "current_year") {
  //       form.setFieldValue("daterange", [
  //         moment().startOf("year"),
  //         moment().endOf("year"),
  //       ]);
  //     } else if (form.getFieldValue("duration") === "today") {
  //       form.setFieldValue("daterange", [moment(), moment()]);
  //     } else if (form.getFieldValue("duration") === "---") {
  //       form.setFieldValue("daterange", [null, null]);
  //     }
  //   }, [form.getFieldValue("duration")]);

  // useEffect(() => {
  //   console.log("Duration changed:", duration);
  //   if (!duration || duration === "---") {
  //     // Reset daterange if duration is cleared
  //     form.setFieldValue("daterange", undefined);
  //     setFilterData((prevValue) => ({ ...prevValue, daterange: undefined }));
  //     SetformData((prevValue) => ({ ...prevValue, daterange: undefined }));
  //     return;
  //   }

  //   let start, end;
  //   if (duration === "last_month") {
  //     start = dayjs().subtract(1, "month").startOf("month");
  //     end = dayjs().subtract(1, "month").endOf("month");
  //   } else if (duration === "current_month") {
  //     start = dayjs().startOf("month");
  //     end = dayjs().endOf("month");
  //   } else if (duration === "current_year") {
  //     start = dayjs().startOf("year");
  //     end = dayjs().endOf("year");
  //   } else if (duration === "today") {
  //     const today = dayjs();
  //     start = today;
  //     end = today;
  //   }

  //   if (start && end) {
  //     form.setFieldValue("daterange", [start, end]);
  //     setFilterData((prevValue) => ({ ...prevValue, daterange: [start, end] }));
  //     SetformData((prevValue) => ({ ...prevValue, daterange: [start, end] }));
  //   }
  // }, [duration, form, SetformData, setFilterData]); // Include form and state setters in dependency array


  
  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedData = { ...formData, [name]: value };
    SetformData(updatedData);
    // getFilterCount(updatedData);

  };

  const handleSelectChange = (field, value) => {
    const updatedData = { ...formData, [field]: value };
    SetformData(updatedData);
    // getFilterCount(updatedData);
  };
  const handleclickme = () => {
    console.log("am clicked");
    SetshowModal(true);
  };

  const handlecancelmodal = () => {
    SetshowModal(false);
  };

  const editModuleupdate = () => {
    filterform?.resetFields();
    setFilterData({
      duration: "today",
      daterange: [dayjs(), dayjs()],
    });
    setFilterData({
       consignee: "",
    driver: "",
    status: "",
    vehicle: "",
    duration: "",
    messagetype: "",
    daterange: [null, null],
    })
    filterform.resetFields("")
      setFilterCount(0);

  };

  // const getFilterCount = (values) => {
  //   const count = Object.values(values).filter(
  //     (val) =>
  //       val !== undefined &&
  //       val !== null &&
  //       val !== "" &&
  //       (!Array.isArray(val) || val.length > 0)
  //   ).length;
  //   setFilterCount(count);
  // };
  console.log(filterCount , "filterCount")
  const handleFilterChange = (e) => {
    const { value, name } = e.target;
    console.log(value, "value---> ", name);

    setFilterData((PrevValue) => ({ ...PrevValue, [name]: value }));
     fetchNotificationLog()
  };

  const handleFilterSelectChange = (field, value) => {
    setFilterData((prevData) => ({
      ...prevData,
      [value]: field,
    }));
        fetchNotificationLog()

  };
  console.log(filterData , "filterData->")


useEffect(()=> {
    const count = Object.values(filterData).filter(
      (val) =>
        val !== undefined &&
        val !== null &&
        val !== "" &&
        (!Array.isArray(val) || val.length > 0)
    ).length;
    console.log(count , "count_12")
    setFilterCount(count - 1);
})




  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
    { label: "---", value: "---" },
  ];

  const MessageType = [
    { label: "Chat", value: "4" },
    { label: "Consignment", value: "2" },
    { label: "Fuel", value: "3" },
    { label: "KPI", value: "6" },
    { label: "SOS", value: "5" },
    { label: "Trip", value: "1" },
  ];

  const renderMessageType = (value) => {
    const type = MessageType.find((item) => item.value === String(value));
    return <span>{type?.label || "-"}</span>;
  };

  const Status = [
    { label: "Read", value: "1" },
    { label: "Unread", value: "2" },
  ];

  const handleCheckboxChange = (key) => {
    console.log(key , "keyky")
    setSelectedKeys((prev) => {
      console.log(prev , "prevprevprev")
      return (
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    )})
  };
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => {
    setIsModalOpen(true); // Open the modal
    console.log("am clicked--->");
  };

  const handleCloseModal = () => {
    console.log("am clicked ---> ");
    setIsModalOpen(false); // Close the modal
  };

  console.log(   "notificationListlength" , "selectedKeylength",  selectedKeys.length,    notificationList.length)
  const columns = [
    {
      title: <Checkbox
       checked={
        notificationList.length > 0 &&
        selectedKeys.length === notificationList.length
      }
      indeterminate={
        selectedKeys.length > 0 &&
        selectedKeys.length < notificationList.length
      }
      onChange={(e) => {
        if (e.target.checked) {
       
          const allKeys = notificationList.map(item => item.ID);
          setSelectedKeys(allKeys);
        } else {
         
          setSelectedKeys([]);
        }
      }}
      
      
      
      
      />, // Select all (optional implementation required)
      dataIndex: "checkbox",
      key: "checkbox",
      width: "5%",
      render: (_, record) => {
         console.log("Renderingrecord", record.ID);
   return(
        <Checkbox
          checked={selectedKeys.includes(record.ID)}
            onChange={() => handleCheckboxChange(record.ID)}
        />
      );
    }
  },
    {
      title: "Message Type",
      dataIndex: "MSGTYPE",
      key: "MSGTYPE",
      width: "10%",
      render: (text, record) => renderMessageType(text),
    },
    {
      title: "Message",
      dataIndex: "MESSAGE",
      key: "MESSAGE",
      width: "50%",
      render: (text) => <div className="text-wrap">{text}</div>, // Wrap text
    },

    {
      title: "Created On",
      dataIndex: "CRON",
      key: "CRON",
      width: "20%",
      render: (text, record) => {
        return (
          <div>
            <p>{record.UserName}</p>
            <i>
              {dayjs(record.CRON).isValid()
                ? dayjs(record.CRON).format("Do MMMM YYYY; hh:mm A")
                : "---"}
            </i>{" "}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "15%",
      render: (text, record) => {
        if (text === "") {
          return <span>Un Read</span>;
        } else {
          return <span>Read</span>;
        }
      },
    },
    {
      title: "Read by",
      dataIndex: "ReadBy",
      key: "ReadBy",
      width: "20%",
      render: (text, record) => {
        return (
          <div>
            <p>{record.ReadBy}</p>
            <i>
              {dayjs(record.READON).isValid()
                ? dayjs(record.READON).format("Do MMMM YYYY; hh:mm A")
                : "---"}
            </i>{" "}
          </div>
        );
      },
    },
  ];

  const [open, setOpen] = useState(false);

  // const handleFormChange = (name, value) => {
  //   setFormData({
  //     ...formData,
  //     [name]: value,
  //   });
  // };
            const unique = [...new Set(driverWithVehicles)]

  const addeditform = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [
          [6, 6, 6, 6],
          [6, 6, 6, 6],
        ],
        fields: [
          [
            {
              name: "consignee",
              label: "Consignee",
              type: "selectwithvalue",
              placeholder: "Select Consignee",
              options: consigneeList?.map((item) => ({
                label: item.Name,
                value: item.Name,
              })),
              onChange: handleChange,
              style: "",
              allowClear:true,
            },
            {
              name: "driver",
              label: "Driver",
              type: "selectwithvalue",
              placeholder: "Select Driver",
              onChange: handleChange,
              options: uniqBy(driverWithVehicles , "DriverName")?.map((item) => ({
                // label: item.DriverName,
                // value: item.VEHID,
                    label: item.DriverName,
                value: item.DriverName,
              })),
            },
            {
              name: "status",
              label: "Status",
              type: "selectwithvalue",
              placeholder: "Select Status",
              onChange: handleChange,
              options: Status?.map((item) => ({
                label: item.label,
                value: item.value,
              })),
            },
            {
              name: "vehicle",
              label: "Vehicle",
              type: "selectwithvalue",
              placeholder: "Select Vehicle",
              value: formData.vehicle,
              onChange: handleChange,
              options: uniqueVehicleLists?.map((item) => ({
                label: item.REGNO,
                value: item.REGNO,
              })),
            },
          ],
          [
            {
              name: "messagetype",
              label: "Message Type",
              type: "selectwithvalue",
              placeholder: "Select Message Type",
              value: formData.messagetype,
              onChange: handleChange,
              options: MessageType?.map((item) => ({
                label: item.label,
                value: item.value,
              })),
            },
            {
              name: "duration",
              label: "Duration",
              type: "selectwithvalue",
              placeholder: "Select Duration",
              onChange: handleChange,
              value: formData.duration,
              options: Duration?.map((item) => ({
                label: item.label,
                value: item.value,
              })),
            },
            {
              label: "Date Range",
              name: "daterange",
              type: "daterange",
              placeholder: ["Start Date", "End Date"],
            },
            {},
          ],
        ],
      },
    ],
  };

  const handleCopyClick = async () => {
    setNewLoading(true);
    try {
      const { data } = await CALL_API("POST", "notif/readAllNotification", {
        MCID: userInfo?.MCID,
        CRBY: userInfo?.UserName,
      });
      message.success("Status changed successfully");
      setIsConformationModal(false);
      setNewLoading(false);
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };

  // const [filterdata, setFilterdata] = useState({});
  const onValuesChange = (changedValues, allValues) => {
    console.log("changedValues--->", changedValues);
    console.log("allValues--->", allValues);
  };

  console.log("Form---->", form);
  const handleSubmit = (values) => {
    console.log("Form submitted with values:", values);
    // Your form submission logic here
  };
  return (
    <Customstyle>
      <div className="d-flex justify-content-between align-items-center">
        <div className="total">{total} Notifications</div>
        <div className="d-flex align-items-center m-3 p-0 gap-5">
          <div>
            {/* <StyledInput
              prefix={
                <SearchOutlined
                  style={{ color: "#636980", cursor: "default" }}
                />
              }
              className="searchbar-style"
            /> */}
          </div>
          <Badge count={filterCount} className="badge">
            <Avatar
              shape="circle"
              size="large"
              src={filtericon}
              className="filterstyle"
              onClick={handleclickme}
            />
          </Badge>
          <ButtonFilled
            type="primary"
            onClick={(e) => {
              e.stopPropagation();
              setIsConformationModal(true);
              // setCopyId(record?.ConsignId);
            }}
          >
            Read All
          </ButtonFilled>
        </div>
      </div>
      <Spin spinning={loading}>
        <StyledTable
          className="mt-4"
          dataSource={notificationList}
          columns={columns}
          pagination={false}
          style={{
            cursor: "pointer",
          }}
          onRow={(record) => ({
            onMouseEnter: () => setHoveredRow(record.key),
            onMouseLeave: () => setHoveredRow(null),
          })}
        />
        <ReusablePagination
          pageSize={pageSize}
          handlePageSizeChange={handlePageSizeChange}
          currentPage={currentPage}
          total={total}
          handlePageChange={handlePageChange}
        />
      </Spin>
      <UIModal
        width={700}
        open={isConformationModal}
        onClose={() => {
          setIsConformationModal(false);
          // setCopyId(null);
        }}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>You want to change the status?</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled loading={newLoading} onClick={handleCopyClick}>
              Yes
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsConformationModal(false);
                // setCopyId(null);
              }}
            >
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <UIModal
        width={1200}
        open={showModal}
        onClose={handlecancelmodal}
        closeButton={false}
        size="lg"
        header={
          <WrapperBox>
            <Row>
              <Col xl={24} sm={24}>
                <div className="modal_container_forfiltermenu">
                  <span className="flilter_five">Filters ({filterCount})</span>
                  {/* <span
                    style={{
                      color: "#2C963D",
                      fontWeight: "400",
                      fontSize: "20px",
                    }}
                  >
                    5 Results Found
                  </span> */}
                </div>
              </Col>
            </Row>
          </WrapperBox>
        }
        footer={
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <ButtonFilled onClick={editModuleupdate}>Clear All</ButtonFilled>
          </div>
        }
      >
        {/* This is the BODY section of the Modal */}
        <WrapperBox>
          <GridBuilder
            formStructureJson={addeditform}
            handleChange={handleFilterChange}
            formSubmit={fetchNotificationLog}
            initialValues={filterData}
            handleSelectChange={handleFilterSelectChange}
            form={filterform}
          />
        </WrapperBox>
      </UIModal>
    </Customstyle>
  );
}

export default Notification;
